export const BLOCK_CUSTOMER = "BLOCK_CUSTOMER";
export const SET_COMMON_LOADER = "SET_COMMON_LOADER"